export const ROLES = {
  admin: 'admin',
  client: 'client',
  analyst: 'analyst',
  superadmin: 'superadmin',
};
